import { combineReducers } from "redux";
import { useSelector } from "react-redux";

import { loginReducer, type LoginState } from "./login";
import { toastReducer, ToastState } from "common-tailwind-components";
import { webpushReducer } from "./webpush";
import { configReducer } from "./config";
import type { ConfigState } from "./config";
export * from "./webpush";

const rootReducer = combineReducers({
  login: loginReducer,
  toast: toastReducer,
  config: configReducer,
  webpush: webpushReducer,
});

export interface AppState {
  login: LoginState;
  toast: ToastState;
  config: ConfigState;
}

export const reducers_map = {};
export const useLogin = () => useSelector((state: AppState) => state.login);
export const useToast = () => useSelector((state: AppState) => state.toast);
export const useConfig = () => useSelector((state: AppState) => state.config);

export default rootReducer;
